import React from 'react';
import styles from './HighlightText.module.scss';

export const HighlightText = ({ text, query }: { text: string, query: string }) => {
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // Added 'i' flag for case-insensitive matching
  const regx = new RegExp(escapedQuery, 'gi');
  //setRegx(new RegExp(`(${escapedQuery.split('').join('|')})`, 'gi'));
  if (!regx) {
    return <>{text}</>;
  }
  const htmlString = text.replace(regx, match => `<span class="${styles.highlight}">${match}</span>`);
  return (
    <span dangerouslySetInnerHTML={{ __html: htmlString }} />
  );
};


